import dayjs from "dayjs";
import { IS_THAILAND } from "../../utils/datePicker";

export const getDateParts = (date, DATE_FORMAT) => {
  let dateParts;

  switch (DATE_FORMAT) {
    case 'DD/MM/YYYY':
    case 'MM/DD/YYYY':
      dateParts = date.split('/').map(Number);
      break;

    case 'YYYY-MM-DD':
    case 'YYYY-DD-MM':
      dateParts = date.split('-').map(Number);
      break;

    case 'YYYY年M月D日': {
      const match = date.match(/^(\d{4})年(\d{1,2})月(\d{1,2})日$/);

      if (!match) return {};

      const [, year, month, day] = match.map(Number);
      return { year, month, day };
    }
  

    default:
      return {};
  }

  switch (DATE_FORMAT) {
    case 'DD/MM/YYYY': {
      const [day, month, year] = dateParts;
      return { month, day, year };
    }

    case 'MM/DD/YYYY': {
      const [month, day, year] = dateParts;
      return { month, day, year };
    }

    case 'YYYY-MM-DD': {
      const [year, month, day] = dateParts;
      return { month, day, year };
    }

    case 'YYYY-DD-MM': {
      const [year, day, month] = dateParts;
      return { month, day, year };
    }

    default:
      return {};
  }
};

const validDate = (publishDate, DATE_FORMAT) => {
  const { month, day, year } = getDateParts(publishDate, DATE_FORMAT);
  if (!month || !day || !year) {
    return false
  }

  if (isNaN(month) || isNaN(day) || isNaN(year) || year < 1000 || year > 9999) {
    return false
  }

  if (month < 1 || month > 12) {
    return false
  }

  if (day < 1 || day > 31) {
    return false
  }

  if (!dayjs(publishDate, DATE_FORMAT, true).isValid()) {
    return false
  }
  return true
}


  export const validatePublishDate = (publishDate, DATE_FORMAT) => {
    if (!publishDate) {
      return true;
    }

    const { month, day, year } = getDateParts(publishDate, DATE_FORMAT);
    if (!month || !day || !year) {
      return `Date must be in ${DATE_FORMAT} format`;
    }

    if (isNaN(month) || isNaN(day) || isNaN(year) || year < 1000 || year > 9999) {
      return `Date must be in ${DATE_FORMAT} format`;
    }

    if (month < 1 || month > 12) {
      return `Month must be between 1 and 12`;
    }

    if (day < 1 || day > 31) {
      return `Day must be between 1 and 31`;
    }

    if (!dayjs(publishDate, DATE_FORMAT, true).isValid()) {
      return `Invalid Start Date`;
    }

    const inputDate = dayjs(publishDate, DATE_FORMAT);
    const currentDate = IS_THAILAND ? dayjs().add(543, 'year') : dayjs();
    const maxFutureDate = currentDate.add(30, 'day');

    if (inputDate.isBefore(currentDate, 'day')) {
      return `Start date cannot be in the past.`;
    }

    if (inputDate.isAfter(maxFutureDate, 'day')) {
      return `Start date cannot be more than 30 days in the future.`;
    }

    return true;
  };


  export const validatePublishTime = (publishDate, publishTime, DATE_FORMAT) => {
    if (!publishTime) {
      return true;
    }
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!timeRegex.test(publishTime)) {
      const [hours, minutes] = publishTime.split(':');
  
      // Validate hours
      if (parseInt(hours) < 0 || parseInt(hours) > 23) {
        return `Hours must be between 00 and 23.`;
      }
  
      // Validate minutes
      if (parseInt(minutes) < 0 || parseInt(minutes) > 59) {
        return `Minutes must be between 00 and 59.`;
      }
  
      // If time format is incorrect (not exactly "HH:MM")
      return `Time must be in HH:MM format (24-hour).`;
    }
    const {month, day, year} = getDateParts(publishDate, DATE_FORMAT);
    const publishDateObj = new Date(year, month - 1, day);
  
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
    const [hrs, mins] = publishTime.split(":").map(Number);

    const inputDate = dayjs(publishDate, DATE_FORMAT);
    const currentDate = IS_THAILAND ? dayjs().add(543, 'year') : dayjs();
    const maxFutureDate = currentDate.add(30, 'day');
    const publishDateTime = new Date(year, month - 1, day, hrs, mins, 0, 0);
    if (validDate(publishDate, DATE_FORMAT) && (publishDateObj.getTime() < today.getTime() || (publishDateObj.getTime() === today.getTime() && publishDateTime.getTime() <= now.getTime()))) {
      return 'Start time cannot be in the past.';
    }

    if (validDate(publishDate, DATE_FORMAT) && inputDate.isAfter(maxFutureDate, 'day')) {
      return `Start Time cannot be more than 30 days in the future.`;
    }
  
    return true;
  };

  export const formatDateByFormat = (date, DATE_FORMAT) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
  
    switch (DATE_FORMAT) {
      case "DD/MM/YYYY":
        return `${day}/${month}/${year}`;
      case "MM/DD/YYYY":
        return `${month}/${day}/${year}`;
      case "YYYY-MM-DD":
        return `${year}-${month}-${day}`;
      case "YYYY-DD-MM":
        return `${year}-${day}-${month}`;
      default:
        return `${day}/${month}/${year}`; // fallback to DD/MM/YYYY
    }
  };
  

  const isCourseScheduleTimeLessThanLP = (courseScheduledTimestamp, publishDate, publishTime, DATE_FORMAT) => {
    const now = new Date();
    const lpPublishDate = publishDate || formatDateByFormat(now, DATE_FORMAT);
              
    const lpPublishTime = publishTime || `${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}`;                  

    const courseTimestamp = new Date(courseScheduledTimestamp);

    const { day, month, year } = getDateParts(lpPublishDate, DATE_FORMAT);
    if (!day || !month || !year) {
      return false;
    }
    const [hours, minutes] = lpPublishTime.split(":").map(Number);

    const lpTimestamp = new Date(year, month - 1, day, hours, minutes);

    if (courseTimestamp.getTime() <= lpTimestamp.getTime()) {
      return true
    } return false
  }

  export const validateCoursesAddedToLP = (addedCourseList, publishDate, publishTime, publishingStatus, DATE_FORMAT) => {
    if(publishingStatus === 'scheduled' && (!publishDate || !publishTime)){
      return true
    }
    for (let i = 0; i < addedCourseList.length; i++) {
      if ((addedCourseList[i].course_state === 'Scheduled' || addedCourseList[i].courseState === 'Scheduled') && addedCourseList[i].scheduledTimestamp && !isCourseScheduleTimeLessThanLP(addedCourseList[i].scheduledTimestamp, publishDate, publishTime, DATE_FORMAT)){
        return false
      }
    }
    return true
  }

  export const getHigheshScheduledTimestamp = (courses, DATE_FORMAT) => {
    const timestamps = courses
    .map(c => {
      if(c.courseState === 'Scheduled')
        return c.scheduledTimestamp
    })
    .filter(Boolean)
    .map(t => new Date(t))
    .filter(d => !isNaN(d.getTime()));

    if (timestamps.length > 0) {
      const earliest = new Date(Math.max(...timestamps.map(d => d.getTime())));
    
      const day = earliest.getDate().toString().padStart(2, "0");
      const month = (earliest.getMonth() + 1).toString().padStart(2, "0");
      const year = earliest.getFullYear();
    
      const hours = earliest.getHours().toString().padStart(2, "0");
      const minutes = earliest.getMinutes().toString().padStart(2, "0");
    
      let formattedDate;
      switch (DATE_FORMAT) {
        case "DD/MM/YYYY":
          formattedDate = `${day}/${month}/${year}`;
          break;
        case "MM/DD/YYYY":
          formattedDate = `${month}/${day}/${year}`;
          break;
        case "YYYY-MM-DD":
          formattedDate = `${year}-${month}-${day}`;
          break;
        case "YYYY-DD-MM":
          formattedDate = `${year}-${day}-${month}`;
          break;
        default:
          formattedDate = `${day}/${month}/${year}`;
      }

      return `${formattedDate} ${hours}:${minutes}`;
    } else {
      return null;
    }
  }